import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap mt-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mx-3" }

import { computed, PropType, ref } from 'vue';
import { IOption, ISuggestion } from '@/lib';
import { getSuggestions } from '@/helpers/search.helper';
import { BaseIcon } from '@/lib/components/Icon';
import SearchInput from './BaseSearchInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicationSearch',
  props: {
  options: {
    type: Array as PropType<IOption[]>,
    required: true,
    validator: (value: IOption[]) => !value.find((option) => !option.value || !option.label)
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  placeholder: {
    type: String,
    default: 'Search'
  },
  error: {
    type: String,
    default: null
  }
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string[]): void;
  (e: 'change', value: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const searchInput = ref(null);

const search = ref('');

const computedModel = computed(() => Array.isArray(props.modelValue) ? props.modelValue : []);
const filteredList = computed<Array<ISuggestion>>(() => props.options
  .filter((option: IOption) => !computedModel.value.includes(option.label))
  .map((option: IOption) => ({ id: option.value, label: option.label })));
const suggestions = computed(() => getSuggestions(filteredList.value, search.value));

const add = (value: ISuggestion) => {
  search.value = '';
  if (!computedModel.value.includes(value.label)) {
    emit('update:modelValue', [...computedModel.value, value.label]);
    emit('change', [...computedModel.value, value.label]);
    searchInput.value.close();
  }
};
const remove = (value: string) => {
  if (computedModel.value.includes(value)) {
    const newItems = computedModel.value.filter((item) => item !== value);

    emit('update:modelValue', newItems);
    emit('change', newItems);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SearchInput, {
      ref_key: "searchInput",
      ref: searchInput,
      modelValue: search.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
      icon: "search",
      suggestions: _unref(suggestions),
      placeholder: __props.placeholder,
      error: __props.error,
      onSubmit: add
    }, null, 8, ["modelValue", "suggestions", "placeholder", "error"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedModel), (value) => {
        return (_openBlock(), _createElementBlock("div", {
          key: value.id,
          class: "flex flex-wrap items-center bg-white m-1 px-3 py-1 rounded-full border hover:shadow-md hover:border-gray-400 cursor-pointer",
          onClick: ($event: any) => (remove(value))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(value), 1),
          _createVNode(_unref(BaseIcon), {
            class: "bg-gray-400 text-white rounded-full text-xl p-1",
            name: "close"
          })
        ], 8, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})